export enum AnswerType {
  right = 'right',
  wrong = 'wrong',
  neutral = 'neutral',
  active = 'active'
}